import React, { useRef } from 'react';
import { FormGroup, HelpBlock } from "react-bootstrap";
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import Creatable from 'react-select/creatable';
import AsyncCreatable from 'react-select/async-creatable';
import i18n from '../../../../utils/ChrI18n';
import { safeMutate } from '../../../../utils/GeneralUtils';
import { getDataFromProps, getUId, propagateData } from '../utils';
import SrLabel from './SrLabel';

// TODO : Introduce PropTypes
// {
//   selectType: AsyncSelect
//   reactSelectOptions: reactSelectOptions,
//   data: <selected data>
// }

// data: { label: "Selected Label", value: "Selected Value", optionalAttr1: "Optional Attr 1" } if reactSelectOptions.isMulti=false
// data: [{ label: "Selected Label", value: "Selected Value", optionalAttr1: "Optional Attr 1" }] if reactSelectOptions.isMulti=true

const selectTypeMap = {
  "AsyncSelect": AsyncSelect,
  "Select": Select,
  "Creatable": Creatable,
  "AsyncCreatable": AsyncCreatable
};

const ChrSelect = props => {
  const {
    hide,
    selectType,
    reactSelectOptions = {}
  } = props;

  const selectWrapperComponent = useRef(null);
  const valueProp = props.valueProp || "defaultValue";

  // TODO_CONNECTION_VIEWS: fix auto close on clicking delete icon in MultiInput
  const reactSelectOnClickHandler = event => {
    event.stopPropagation();
    selectWrapperComponent.current && selectWrapperComponent.current.click();
  };

  const displayClass = hide ? "hide" : "";
  const formGroupClass = [props.formGroupClass, displayClass].join(" ");
  const classNamePrefix = [props.classNamePrefix, "cjs-chr-select"].join(" ");
  const SelectType = selectType ? selectTypeMap[selectType] : Select;

  const onChangeHandler = (selectedEntry) => {
    const newSelectedEntry = safeMutate(selectedEntry, draftSelectedEntry => (draftSelectedEntry || {}));
    propagateData("onChange", getUId(props), newSelectedEntry, props);
  };

  const formData = getDataFromProps(props);
  const placeholder = reactSelectOptions.placeholder || props.placeholder || i18n.t("display_string.Select")
  reactSelectOptions["aria-label"] = reactSelectOptions["aria-label"] || placeholder;
  const srLabel = reactSelectOptions.srLabel || props.srLabel

  return (
    <React.Fragment>
      <div ref={ selectWrapperComponent } className={props.className}>
        <div onClick={ reactSelectOnClickHandler }>
          <FormGroup className={ formGroupClass }>
            { srLabel && <SrLabel>{ srLabel }</SrLabel> }
            <SelectType
              { ...reactSelectOptions }
              placeholder={ placeholder }
              className={ reactSelectOptions.className || "custom-width-17 break-word-all" }
              { ...{ [valueProp]: formData } }
              onChange={ onChangeHandler }
              noOptionsMessage={ (_input) => i18n.t("display_string.see_n_results.zero") }
              loadingMessage={ (_input) => i18n.t("display_string.Loading") }
              captureMenuScroll= {false}
              classNamePrefix={ classNamePrefix }
            />
            { props.error && <HelpBlock className="block">{ props.error }</HelpBlock> }
          </FormGroup>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ChrSelect;
